import { render, staticRenderFns } from "./TTB.vue?vue&type=template&id=cc620ac0&scoped=true&"
import script from "./TTB.vue?vue&type=script&lang=js&"
export * from "./TTB.vue?vue&type=script&lang=js&"
import style0 from "./TTB.vue?vue&type=style&index=0&id=cc620ac0&scoped=true&lang=css&"
import style1 from "./TTB.vue?vue&type=style&index=1&id=cc620ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc620ac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCheckbox,VCol,VCombobox,VContainer,VRow,VSimpleTable,VTextField})
